// Google OAuth 2.0 — client-side with Google Identity Services
// Uses the newer GIS library (gsi) instead of deprecated gapi

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "";

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: Record<string, unknown>) => void;
          prompt: () => void;
          renderButton: (el: HTMLElement, config: Record<string, unknown>) => void;
        };
      };
    };
  }
}

let gsiLoaded = false;

export function loadGoogleScript(): Promise<void> {
  if (gsiLoaded) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => { gsiLoaded = true; resolve(); };
    script.onerror = () => reject(new Error("Failed to load Google Identity Services"));
    document.head.appendChild(script);
  });
}

export async function initGoogleLogin(
  onSuccess: (idToken: string) => void,
  buttonElement?: HTMLElement,
): Promise<void> {
  await loadGoogleScript();

  if (!window.google) throw new Error("Google Identity Services not available");

  window.google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: (response: { credential: string }) => {
      onSuccess(response.credential);
    },
    auto_select: false,
    cancel_on_tap_outside: true,
  });

  if (buttonElement) {
    window.google.accounts.id.renderButton(buttonElement, {
      type: "standard",
      theme: "outline",
      size: "large",
      text: "continue_with",
      shape: "pill",
      width: "100%",
      locale: "tr",
    });
  } else {
    window.google.accounts.id.prompt();
  }
}
